import httpClient from '@yola/http-client';
import i18next from 'i18next';

import actionTypes from '../constants/action-types';
import constants from '../constants';

const translationsLoader = () => (next) => (action) => {
  switch (action.type) {
    case actionTypes.SET_LOCALE: {
      const { locale } = action.payload;
      const { language } = i18next;
      if (language === locale) {
        next(action);
        break;
      }
      if (i18next.hasResourceBundle(locale, constants.DEFAULT_I18NEXT_NAMESPACE)) {
        i18next.changeLanguage(locale).then(() => next(action));
        break;
      }
      httpClient
        .get(`/locale/${locale}.json`)
        .then(({ data }) => {
          i18next.addResourceBundle(locale, constants.DEFAULT_I18NEXT_NAMESPACE, data, true, true);
          i18next.changeLanguage(locale).then(() => next(action));
        })
        .catch(() => {
          httpClient
            .get(`/locale/${constants.DEFAULT_LOCALE}.json`)
            .then(({ data }) => {
              i18next.addResourceBundle(
                constants.DEFAULT_LOCALE,
                constants.DEFAULT_I18NEXT_NAMESPACE,
                data,
                true,
                true
              );
              i18next.changeLanguage(constants.DEFAULT_LOCALE).then(() => next(action));
            })
            .catch(() => next(action));
        });
      break;
    }
    default:
      next(action);
  }
};
export default translationsLoader;
